var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5643_257674",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5643_257674",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAD30lEQVR4nO2cTWgVZxSGn5go1WoLLYiCiVWpJquWgH+raK0USptqd4rQTaGQUmhWpdDQRaH4gwhushKEbroRBOkiWLpw4cautELA2pSqdWGLIdhiNM3tYjKgyc2939/MuffO+8Ahm/ne75zzzv0y95u5A0IIIYQQQgghhBCiKnQFjKkVoFlZVlgnUHVkgDEywBgZYIwMMEYGGCMDjJEBxsgAY2SAMTLAGBlgjAzwZxMwaplArUl0Mr3ALbI6T1olUVUDeoFfeb7WExaJVNGAPpY2P4+vy06magb0AbdpXPNYmQlVyYCtwO80r7kGfBkyQTtfBXUBZyhuHd4M/Ljwtxn/AfcKymMJrfAJ6ALOPjPnOGlPpteAKdzO/DngWMK5m2JtwArgXJ15vwN6Eui/Dtyto98SzcchqSLpBs43mPt7YGWE/nb8mn80Yq5grAzoJjvLm81/CXghQH8H2Tru2vwj4aXEYWHAKuCCw9x5/ASs9dD3af4T4HBsQTGUbcAq4KLDvIvjCvCSg34/8Kej5ixwKE1Z4ZRpwGpgwmHO5eJn4NUG+gP4Nf+DlMWFUpYBa4DLDvM1i5vAxjr6A8B9R41ZYDhhbVGUYcCLZOt4bPPzmCTbRs55A3jgOHYWeD9RXUko2oCXgasO8/jGFLANeBP35j8G3ktQU1KKNOAV4JrDHHmMk+3Lux5/B/jb8dh/gYOR9RRCUQaEND9/FP4Lj3Eu8Q/wdkQthVKEAeuB6w7aeZyqo/EpMO+h0aj5BwLrKIXUBmwAfnHQzeN4A61PyHYmY5r/VkANpZLSgGfvscY2P+co8NRDM49HwH7P/E1IZcBmlr/NVy++8tAeJruC8Wn+Pg99U1IYsAX4zUGrRraufx6Q57tkVzIuzR8K0Dcj1oAduG/5zgOfReQ6BMw00J8G9kbomxBjgM/eyzwwkiDfndS/9p8G9iTQL51QA3y+gc4BHyXMeXDR3NPA7oT6pRJiwCDwl8PYvPlF3OYbINvzfwjsKkC/NEIMGHEYVyPb+PqwwNy3k50MbU3oEjTaZFxL3OxoB2L+CY8tM+YxLbbl28rEXoZ+s+j4lt74akViDQD4duHYR7TB3kurkcIAyExouy9BqdHraoxp54dzOwIZYIwMMEYGGCMDjJEBxsgAY2SAMTLAGBlgjAwwRgYYIwOMkQHGyABjZIAxITdPZoB1qRPpILx6GvIJ+CNgjFiGEAMmkmdRYUKWoH7gBmneTNKJFL4ETZK9q0cY0gP8gNvznlWL0ugBThP2e6xODi9SPMPTD3wMvEP2qi+f18R0InouSgghhBBCCCGEEELU5X+/68zaFSPjfgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnGraph);
export default __webpack_public_path__ + "static/media/icn_graph.296ac2943833d759795d64214facc515.svg";
export { ForwardRef as ReactComponent };